import React, { useState, useEffect, useContext } from "react";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import http from "../services/http";
import UsersTable from "../components/usersTable";
import Input from "../components/common/input";
import { paginate } from "../utils/paginate";
import Pagination from "../components/common/pagination";
import Checkbox from "../components/common/checkbox";
import Loading from "../components/common/loading";
import UserContext from "../context/userContext";

const apiEndPoint = "/users";

const Users = () => {
  const [user] = useContext(UserContext);

  const [users, setUsers] = useState([]);
  const pageSize = 12;
  const navigation = '';
  
  const [currentPage, setCurrentPage] = useState(1);
  const [query, setQuery] = useState("");
  const [hideArchived, setHideArchived] = useState(true);
  const [localSite, setLocalSite] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "FTR - Users";
    return () => {
      document.title = "FTR";
    };
  }, []);

  useEffect(() => {
    async function getUsers() {
      try {
        const { data } = await http.get(apiEndPoint + "/all");
        setUsers(data);
      }
      catch {
        //ignore error
      }

      setLoading(false);
    }
    if (user) {
      getUsers();
    }
  }, [user]);

  async function handleArchive(user) {
    const oldUsers = [...users];
    const newUsers = [...users];
    const userIndex = newUsers.findIndex((u) => u.USERNAME === user.USERNAME);
    newUsers[userIndex] = { ...newUsers[userIndex], ACTIVE: !user.ACTIVE };
    setUsers(newUsers);
    try {
      const { data } = await http.patch(`/user/archive/${user.USERNAME}`);
      toast.success(data);
    } catch (ex) {
      setUsers(oldUsers);
      console.log(ex);
    }
  }

  let filtered = users.filter((u) => u.USERNAME !== user.USERNAME);
  if (query)
    filtered = users.filter(
      (u) =>
        u.USERNAME.includes(query.toUpperCase()) ||
        (u.FULL_NAME && u.FULL_NAME.toUpperCase().includes(query.toUpperCase()))
    );
  if (hideArchived) {
    filtered = filtered.filter((u) => u.ACTIVE);
  }
  if (localSite) {
    filtered = filtered.filter((u) => u[`ACCESS_${user.SITE}`]);
  }
  let data = paginate(filtered, currentPage, pageSize);

  return (
    <div className="col mt-4">
      <div className="row">
        <div className="col-auto ml-3">
          <Link to="/users/new">
            <button className="btn btn-primary">
              <i className="fas fa-user-plus fa-lg mx-1"></i>
            </button>
          </Link>
        </div>
        <div className="col-auto">
          <Checkbox
            name="hideArchived"
            label="Hide Archived"
            checked={hideArchived}
            onClick={() => {
              setHideArchived(!hideArchived);
              setCurrentPage(1);
            }}
          />
          <Checkbox
            name="filterSite"
            label="Current Site Only"
            checked={localSite}
            onClick={() => {
              setLocalSite(!localSite);
              setCurrentPage(1);
            }}
          />
        </div>
        <div className="col">
          <Input
            name="search-users"
            placeholder="Search Users..."
            value={query}
            onChange={(e) => {
              setQuery(e.currentTarget.value);
              setCurrentPage(1);
            }}
          />
        </div>
      </div>
      {loading ? (
        <Loading />
      ) : (
        <React.Fragment>
          <UsersTable
            data={data}
            onClick={handleArchive}
            length={filtered.length}
          />
          <Pagination
            itemsCount={filtered.length}
            pageSize={pageSize}
            currentPage={currentPage}
            onPageChange={(p) => setCurrentPage(p)}
            navigation={navigation}
          />
        </React.Fragment>
      )}
    </div>
  );
};

export default Users;
